/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-adverse-event.reducer';

export const BloodBankAdverseEventDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankAdverseEventEntity = useAppSelector(state => state.bloodBankAdverseEvent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankAdverseEventDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.detail.title">BloodBankAdverseEvent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.id}</dd>
          <dt>
            <span id="reactionDate">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionDate">Reaction Date</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.reactionDate}</dd>
          <dt>
            <span id="reactionType">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionType">Reaction Type</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.reactionType}</dd>
          <dt>
            <span id="reactionDescription">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionDescription">Reaction Description</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.reactionDescription}</dd>
          <dt>
            <span id="severity">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.severity">Severity</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.severity}</dd>
          <dt>
            <span id="reportedTo">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reportedTo">Reported To</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.reportedTo}</dd>
          <dt>
            <span id="actionTaken">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.actionTaken">Action Taken</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.actionTaken}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankAdverseEventEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.inventory">Inventory</Translate>
          </dt>
          <dd>{bloodBankAdverseEventEntity.inventory ? bloodBankAdverseEventEntity.inventory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.bank">Bank</Translate>
          </dt>
          <dd>{bloodBankAdverseEventEntity.bank ? bloodBankAdverseEventEntity.bank.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-adverse-event" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-adverse-event/${bloodBankAdverseEventEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankAdverseEventDetail;
